module.exports = __webpack_public_path__ + "static/media/Punjab Assembly House Alfalah building charring cross.a172b0aa.jpeg";